"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferSortableField = void 0;
var TransferSortableField;
(function (TransferSortableField) {
    TransferSortableField["DEBITING_CURRENCY"] = "debitingCurrency";
    TransferSortableField["FUNDING_CURRENCY"] = "fundingCurrency";
    TransferSortableField["AMOUNT"] = "instructedAmount";
    TransferSortableField["VALUE_DATE"] = "valueDate";
    TransferSortableField["FUNDING_ACCOUNT"] = "fundingAccountName";
    TransferSortableField["DEBITING_ACCOUNT"] = "debitingAccountName";
    TransferSortableField["REFERENCE"] = "reference";
    TransferSortableField["STATUS"] = "transferStatus";
})(TransferSortableField = exports.TransferSortableField || (exports.TransferSortableField = {}));
